import { MainContent, TopBar } from '@domain-group/suit-theme'

import useMainNavigation from '@hooks/useMainNavigation'

import LoggedInUser from '@components/LoggedInUser'
import MainNavigation from '@sections/Admin/components/MainNavigation'

import PublicationManagerRoutes from './routes'

const PublicationManager = () => {
  const { callbacks: { toggleNavigation } } = useMainNavigation()

  return <PublicationManagerRoutes />

  return (
    <>
      <TopBar
        callbacks={{ toggleNavigation }}
        loggedInUserComponent={<LoggedInUser />}
        // @ts-expect-error TS2322
        searchComponent={<TopBar.Search callbacks={{ search: null }} />}
      />

      <MainNavigation />

      <MainContent offset={{ top: TopBar.topBarHeight }}>
        <PublicationManagerRoutes />
      </MainContent>
    </>
  )
}

export default PublicationManager
